/**
 * 文件上传相关配置
 */
export const FILE_BASE_URL = "https://bhgj.image.cldwork.cn";
export const ACTION_URL = "https://upload-z2.qiniup.com";
export const UPLOAD_TOKEN =
  "9a4FjnalaaKsh6A3cN0sccXKA4wrOCgaCZtgYWE4:RIzbUE3jKbjm45XZtvUN0yEYayg=:eyJzY29wZSI6ImJoZ2oiLCJkZWFkbGluZSI6MTgxODk4MjY3NH0=";
